
const appAccoutTypes = [
  {
    key: 'Other',
    name: '其他',
    value: 0,
  },
  {
    key: 'WXPay',
    name: '微信支付',
    value: 10,
  },
  {
    key: 'WXApp',
    name: '微信小程序',
    value: 20,
  },
  {
    key: 'WXPublicApp',
    name: '微信公众号',
    value: 30,
  },
]

const appointType = [
  {
    key: 'Bussiness',
    name: '业务',
    value: 2,
  },
  {
    key: 'Bussiness',
    name: '招聘',
    value: 4,
  },
]


const adSpace = [
  {
    key: 'HomePage',
    name: '主页轮播',
    value: 0,
  },
  // {
  //   key: 'ChannelPage',
  //   name: '频道轮播',
  //   value: 10,
  // }
]

const categoryType = [
  // {
  //   key: 'Common',
  //   name: '综合',
  //   value: 2,
  // },
  {
    key: 'Convenient',
    name: '生活圈',
    value: 4,
  },
  {
    key: 'Bussiness',
    name: '商业圈',
    value: 8,
  },
]

const memberType = [
  {
    key: 'Member',
    name: '个人',
    value: 0,
  },
  {
    key: 'CorpManager',
    name: '企业主',
    value: 10,
  },
  {
    key: 'PlatManager',
    name: '平台管理',
    value: 20,
  },
]


const appointStatus = [
  {
    key: 'Create',
    name: '意向',
    value: 0,
  },
  {
    key: 'Success',
    name: '达成',
    value: 10,
  },
  {
    key: 'Cancel',
    name: '未达成',
    value: 20,
  },
]

const tenantType =[{
  key: 'Plat',
  name: '平台',
  value: 0,
},{
  key: 'Corp',
  name: '企业',
  value: 2,
},
{
  key: 'Partner',
  name: '伙伴',
  value: 4,
}]

const tenantStatus=[{
  key: 'Audit',
  name: '待审',
  value: 0,
},
{
  key: 'Online',
  name: '上线',
  value: 2,
},
{
  key: 'Offline',
  name: '下线',
  value: 4,
}]

const attachmentType=[
  {
  key: 'Other',
  name: '其他',
  value: 0,
},
  {
  key: 'Logo',
  name: 'Logo',
  value: 1,
},
{
  key: 'BusinessLicense',
  name: '营业执照',
  value: 2,
},
{
  key: 'FigureImage',
  name: '企业形象图',
  value: 5,
}]

export default {
  appAccoutTypes,
  appointStatus,
  memberType,
  appointType,
  tenantStatus,
  tenantType,
  categoryType,
  attachmentType,
  adSpace
}
